module.exports = __webpack_public_path__ + "static/media/intergr8-logo.be1b1951.jpg";